module.exports = __webpack_public_path__ + "img/mercadopago.7eb70c6a.svg";